import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const StyledTooltipWrapper = styled.div`
  max-width: 70rem;
`;
const StyledTooltipContent = styled.div`
  min-width: 30rem;
`;

const MIN_WIDTH = 0;

const TooltipWrapper = ({ tooltip }) => {
  const ref = useRef(null);
  const [refWidth, setRefWidth] = useState(MIN_WIDTH);

  useEffect(() => {
    if (ref.current) {
      const componentWidth = ref.current.offsetWidth;
      if (componentWidth > refWidth && componentWidth > MIN_WIDTH) {
        setRefWidth(componentWidth);
      }
    }
  }, [ref?.current?.offsetWidth]);

  const shouldAppendWidth = refWidth > MIN_WIDTH;

  return (
    <StyledTooltipWrapper
      style={{
        ...(shouldAppendWidth && { width: `${refWidth}px` })
      }}
    >
      <StyledTooltipContent ref={ref}>{tooltip}</StyledTooltipContent>
    </StyledTooltipWrapper>
  );
};

export default TooltipWrapper;
